import images from './lib/lazy-image.js'

const init = types => (ctx = document) => {
  for (let type in types) {
    const attr = 'data-' + type
    const nodes = [].slice.call(ctx.querySelectorAll(`[${attr}]`))

    for (let i = 0; i < nodes.length; i++) {
      try {
        require(types[type] + nodes[i].getAttribute(attr) + '.js').default(nodes[i])
      } catch (e) {
        console.error(e)
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', e => {
  images.bind()
  init({
    component: './components/'
  })()
})



// WEBPACK FOOTER //
// ./src/scripts/app.js